import React, {useState} from 'react'
import ProgressBubbles from '../partials/ProgressBubbles';
import globals from '../../globals.json';

function CarouselItem(props) {
  return (
    <div className={`CarouselItem ${props.position}`}>
      <img className="context-img" src={props.data.img} alt="carousel"/>
      <div className="text-content" dangerouslySetInnerHTML={{__html: props.data.text}}></div>
    </div>
  )
}


export default function Carousel(props) {
  const [itemIndex, setItemIndex] = useState(0);
  const [completed, setCompleted] = useState(false);
  const [animating, setAnimating] = useState(false);

  const startAnimating = () => {
    setAnimating(true);
    setTimeout(() => setAnimating(false), 1100);
  }
  const nextItem = () => {
    startAnimating();
    if (itemIndex === props.data.items.length - 2) {
      setCompleted(true)
    }
    if (itemIndex < props.data.items.length - 1) {
      setItemIndex(itemIndex + 1);
    }
  }

  const prevItem = () => {
    startAnimating();
    if (itemIndex > 0) {
      setItemIndex(itemIndex - 1);
    }
  }

  const generateCarouselItem = (i, position) => {
    if (i >= 0 && i < props.data.items.length) {
      return (
        <CarouselItem key={i} position={position} data={props.data.items[i]}/>
      )
    } else {
      return null;
    }

  }

  const generateCarouselItems = () => {
    //we might need to add farleft and farright if use spam click is possible?
    const items = props.data.items;
    let jsx = [];
    //left
    if (itemIndex > 0) {
      jsx.push(generateCarouselItem(itemIndex - 1, 'left'))
    }
    //center
    jsx.push(generateCarouselItem(itemIndex, 'center'))

    //right
    if (itemIndex < items.length - 1) {
      jsx.push(generateCarouselItem(itemIndex + 1, 'right'))

    }
    return jsx;
  }


  const checkComplete = () => {
    return completed;
  }

  return (
    <div className={`Carousel ${props.data.class}`}>
      <h1 className="header-text">{props.data.headerText}</h1>
      <div className="body-text" dangerouslySetInnerHTML={{__html: props.data.bodyText}}></div>
      <div className="instructions" dangerouslySetInnerHTML={{__html: props.data.instructionText}}></div>
      <button className={`button ${animating ? 'disabled' : 'active'}`} onClick={prevItem}>{"<"}</button>
      <ProgressBubbles total={props.data.items.length} current={itemIndex + 1}/>
      <button className={`button ${animating ? 'disabled' : 'active'}`} onClick={nextItem}>{">"}</button>
      <div className="wrapper">
        {generateCarouselItems()}
      </div>

      {checkComplete() && <div className="next-button" onClick={props.onComplete}>{globals.nextButtonText}</div>}
    </div>
  )
}
